"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinationsWithRepDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var combinationsWithRepDependencies = exports.combinationsWithRepDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCombinationsWithRep: _factoriesAny.createCombinationsWithRep
};